/* c4-pa-size.js (9 Oct 2026) — feeds the chosen print size to the Print.App editor.
   Same idea as PitchPrint's canvas adjuster reading Apippa's [data-calcname='Width (mm)'] /
   [data-calcname='Height (mm)'] fields: Print Options has no width/height on its Size choices, so
   this keeps two hidden inputs in step with the configurator's Size + Orientation, and Print.App
   connectors ("Product Page Element" -> #c4-pa-width / #c4-pa-height) read them.
   Size comes from the choice label ("Small 400 x 600 mm"); Orientation "Landscape" puts the long
   side across. Values are trim + bleed (5 mm each side), in mm. A size with no numbers in its label
   (e.g. "Digital file only") leaves the last values in place. Does nothing without a configurator. */
(function () {
  'use strict';
  var BLEED = 10; // 5 mm each side
  function dims(label) {
    var m = /(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/i.exec(label || '');
    return m ? [parseFloat(m[1]), parseFloat(m[2])] : null;
  }
  function inputs() {
    var box = document.getElementById('c4-pa-size');
    if (!box) {
      box = document.createElement('div');
      box.id = 'c4-pa-size';
      box.hidden = true;
      box.innerHTML = '<input type="text" id="c4-pa-width" data-calcname="Width (mm)" value="" autocomplete="off" tabindex="-1">' +
                      '<input type="text" id="c4-pa-height" data-calcname="Height (mm)" value="" autocomplete="off" tabindex="-1">';
      document.body.appendChild(box);
    }
    return [document.getElementById('c4-pa-width'), document.getElementById('c4-pa-height')];
  }
  function chosen(po, role) {
    var f = po.field && po.field(role), st = po.state;
    if (!f || !st || !st.selections) return '';
    var id = st.selections[f.id];
    var opts = f.options || [];
    for (var i = 0; i < opts.length; i++) if (opts[i].id === id) return opts[i].label || '';
    return '';
  }
  function set(el, v) {
    v = String(v);
    if (el.value === v) return;
    el.value = v;
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function update() {
    var po = document.querySelector('print-configurator');
    if (!po || !po.state) return;
    var d = dims(chosen(po, 'size'));
    if (!d) return;
    var w = Math.min(d[0], d[1]), h = Math.max(d[0], d[1]);
    if (/landscape/i.test(chosen(po, 'orientation'))) { var t = w; w = h; h = t; }
    var el = inputs();
    set(el[0], w + BLEED);
    set(el[1], h + BLEED);
  }
  function boot() {
    var po = document.querySelector('print-configurator');
    if (!po) return;
    inputs();
    po.addEventListener('ready', update);
    po.addEventListener('change', update);
    update();
    window.c4PaSize = update;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
